import Vue from 'vue';

export default new Vue({
    data() {
        return {
            sportNameCn: null,
            sportNameEn: null,
            showAll: true
        }
    }
});